// extracted by mini-css-extract-plugin
module.exports = {"tab-panel":"style_tab-panel__8zqsM"};